import { defineMessages } from 'react-intl'

export default defineMessages({
  paymentInsurancesHeadline: {
    id: 'app.payment.insurances.headline',
    defaultMessage: 'Your insurance companies',
  },
  paymentHeadline: {
    id: 'app.payment.headline',
    defaultMessage: 'Payment',
  },
  paymentSelectPolicyBelow: {
    id: 'app.payment.policies.selectPolicyBelow',
    defaultMessage: 'Please select policy below',
  },

  paymentLabelPaymentInformation: {
    id: 'app.payment.label.paymentInformation',
    defaultMessage: 'Payment Information',
  },
  paymentTitlePaymentType: {
    id: 'app.payment.title.paymentType',
    defaultMessage: 'Payment Type',
  },
  paymentTitlePaymentTypeCard: {
    id: 'app.payment.title.paymentTypeCard',
    defaultMessage: 'Credit Card',
  },
  paymentTitlePaymentTypeAch: {
    id: 'app.payment.title.paymentTypeAch',
    defaultMessage: 'Ach',
  },
  paymentLabelAmount: {
    id: 'app.payment.label.ePayAmount',
    defaultMessage: 'Amount',
  },
  paymentLabelNameOnTheCard: {
    id: 'app.payment.label.nameOnTheCard',
    defaultMessage: 'Cardholder Name',
  },
  paymentLabelCardNumber: {
    id: 'app.payment.label.cardNumber',
    defaultMessage: 'Card Number',
  },
  paymentLabelExpirationDate: {
    id: 'app.payment.label.expirationDate',
    defaultMessage: 'Expiration Date',
  },
  paymentLabelCardPostalCode: {
    id: 'app.payment.label.cardPostalCode',
    defaultMessage: 'Postal Code',
  },
  paymentLabelAchBankAccountHolder: {
    id: 'app.payment.label.ach.bankAccountHolder',
    defaultMessage: 'Bank Account Holder',
  },
  paymentLabelAchRoutingNumber: {
    id: 'app.payment.label.ach.routingNumber',
    defaultMessage: 'Routing Number',
  },
  paymentLabelAchAccountNumber: {
    id: 'app.payment.label.ach.accountNumber',
    defaultMessage: 'Account Number',
  },
  paymentLabelAchConfirmAccountNumber: {
    id: 'app.payment.label.ach.confirmAccountNumber',
    defaultMessage: 'Confirm Account Number',
  },
  paymentLabelPaymentNotes: {
    id: 'app.payment.label.paymentNotes',
    defaultMessage: 'Notes',
  },
  paymentLabelPaymentNotesPlaceholder: {
    id: 'app.payment.label.paymentNotesPlaceholder',
    defaultMessage: 'Notes: e.g. Agency Code, Quote...',
  },
  paymentLabelPayersName: {
    id: 'app.payment.label.payersName',
    defaultMessage: "Payer's Name",
  },
  paymentLabelPayersEmail: {
    id: 'app.payment.label.payersEmail',
    defaultMessage: "Payer's Email",
  },
  paymentLabelPolicyNumber: {
    id: 'app.payment.label.policyNumber',
    defaultMessage: 'Policy Number',
  },
  paymentLabelCard: {
    id: 'app.payment.label.card',
    defaultMessage: 'Card',
  },
  paymentLabelFee: {
    id: 'app.payment.label.fee',
    defaultMessage: 'Fee',
  },
  paymentLabelTotal: {
    id: 'app.payment.label.total',
    defaultMessage: 'Total',
  },
  paymentLabelTotalPaymentAmount: {
    id: 'app.payment.label.totalPaymentAmount',
    defaultMessage: 'Total Payment Amount',
  },
  paymentLabelThankYouTitle: {
    id: 'app.payment.label.thankYouTitle',
    defaultMessage: 'Thank you for your payment!',
  },
  paymentFormErrorAmount: {
    id: 'app.payment.formError.amount',
    defaultMessage: 'Amount is required',
  },
  paymentFormErrorAmountInvalid: {
    id: 'app.payment.formError.amountInvalid',
    defaultMessage: 'Allowed amount is between {min} and {max}',
  },
  paymentFormErrorNameOnTheCard: {
    id: 'app.payment.formError.nameOnTheCard',
    defaultMessage: 'Card name is required',
  },
  paymentFormErrorNameOnTheCardInvalid: {
    id: 'app.payment.formError.nameOnTheCardInvalid',
    defaultMessage: 'Card name is invalid',
  },
  paymentFormErrorCardNumber: {
    id: 'app.payment.formError.cardNumber',
    defaultMessage: 'Card number is required',
  },
  paymentFormErrorCardNumberInvalid: {
    id: 'app.payment.formError.cardNumberInvalid',
    defaultMessage: 'Card number is invalid',
  },
  paymentFormErrorCardMonth: {
    id: 'app.payment.formError.cardMonth',
    defaultMessage: 'Month is required',
  },
  paymentFormErrorCardMonthInvalid: {
    id: 'app.payment.formError.cardMonthInvalid',
    defaultMessage: 'Month is invalid',
  },
  paymentFormErrorCardYear: {
    id: 'app.payment.formError.cardTear',
    defaultMessage: 'Year is required',
  },
  paymentFormErrorCardYearInvalid: {
    id: 'app.payment.formError.cardYearInvalid',
    defaultMessage: 'Year is invalid',
  },
  paymentFormErrorCardCvc: {
    id: 'app.payment.formError.cardCvc',
    defaultMessage: 'CVC is required',
  },
  paymentFormErrorCardCvcInvalid: {
    id: 'app.payment.formError.cardCvcInvalid',
    defaultMessage: 'CVC is invalid',
  },
  paymentFormErrorCardPostalCodeInvalid: {
    id: 'app.payment.formError.cardPostalCodeInvalid',
    defaultMessage: 'Postal Code is invalid',
  },
  paymentFormErrorCardPostalCodeInvalidLength: {
    id: 'app.payment.formError.cardPostalCodeInvalidLength',
    defaultMessage: 'Postal Code can not be longer than {max} characters',
  },
  paymentFormErrorCardNoteInvalid: {
    id: 'app.payment.formError.cardNoteInvalid',
    defaultMessage: 'Note can not be longer than {max} characters',
  },
  paymentFormErrorPayersName: {
    id: 'app.payment.formError.payersName',
    defaultMessage: "Payer's Name is required",
  },
  paymentFormErrorPayersNameInvalid: {
    id: 'app.payment.formError.payersNameInvalid',
    defaultMessage: "Payer's Name can not be longer than {max} characters",
  },
  paymentFormErrorPayersEmail: {
    id: 'app.payment.formError.payersEmail',
    defaultMessage: "Payer's Email is required",
  },
  paymentFormErrorPayersEmailInvalid: {
    id: 'app.payment.formError.payersEmailInvalid',
    defaultMessage: "Payer's Email can not be longer than {max} characters",
  },
  paymentFormErrorPolicyNumberInvalid: {
    id: 'app.payment.formError.policyNumberInvalid',
    defaultMessage: 'Policy Number can not be longer than {max} characters',
  },
  paymentFormErrorAchBankAccountHolder: {
    id: 'app.payment.formError.ach.bankAccountHolder',
    defaultMessage: 'Bank account holder is required',
  },
  paymentFormErrorAchBankAccountHolderInvalid: {
    id: 'app.payment.formError.ach.bankAccountHolderInvalid',
    defaultMessage: 'Bank account holder can not be longer than {max} characters',
  },
  paymentFormErrorAchRoutingNumber: {
    id: 'app.payment.formError.ach.routingNumber',
    defaultMessage: 'Routing number is required',
  },
  paymentFormErrorAchRoutingNumberValid: {
    id: 'app.payment.formError.ach.routingNumberValid',
    defaultMessage: 'Routing number is not valid',
  },
  paymentFormErrorAchRoutingNumberNotNumber: {
    id: 'app.payment.formError.ach.routingNumberNotNumber',
    defaultMessage: 'Routing number needs to be a number',
  },
  paymentFormErrorAchRoutingNumberLength: {
    id: 'app.payment.formError.ach.routingNumberLength',
    defaultMessage: 'Routing number must be 9 characters',
  },
  paymentFormErrorAchAccountNumber: {
    id: 'app.payment.formError.ach.accountNumber',
    defaultMessage: 'Account number is required',
  },
  paymentFormErrorAchAccountNumberNotNumber: {
    id: 'app.payment.formError.ach.accountNumberNotNumber',
    defaultMessage: 'Account number needs to be a number',
  },
  paymentFormErrorAchAccountNumberInvalid: {
    id: 'app.payment.formError.ach.accountNumberInvalid',
    defaultMessage: 'Account number can not be longer than {max} characters',
  },
  paymentFormErrorAchConfirmAccountNumber: {
    id: 'app.payment.formError.ach.confirmAccountNumber',
    defaultMessage: 'Please confirm account number',
  },
  paymentFormErrorAchConfirmAccountNumberNotNumber: {
    id: 'app.payment.formError.ach.confirmAccountNumberNotNumber',
    defaultMessage: 'Needs to be a number',
  },
  paymentFormErrorAchConfirmAccountNumberMismatch: {
    id: 'app.payment.formError.ach.confirmAccountNumberMismatch',
    defaultMessage: 'Needs to match account number',
  },

  // E-transfer
  paymentLabelETransferInstructions: {
    id: 'app.payment.label.eTransferInstructions',
    defaultMessage: 'E-transfer Instructions',
  },
  paymentFormLabelSecretPassword: {
    id: 'app.payment.formLabel.secretPassword',
    defaultMessage: 'Secret Password',
  },
  paymentFormErrorSecretPassword: {
    id: 'app.payment.formError.secretPassword',
    defaultMessage: 'Secret Password is required!',
  },
  paymentLabelAchAccountNumberTitle: {
    id: 'app.payment.label.ach.accountNumberTitle',
    defaultMessage: 'Where to find Routing and Account number?',
  },
  paymentLabelAchHelpYourName: {
    id: 'app.payment.label.ach.help.yourName',
    defaultMessage: 'Your Name',
  },
  paymentLabelAchHelpYourAddress: {
    id: 'app.payment.label.ach.help.yourAddress',
    defaultMessage: 'Your Address',
  },
  paymentLabelAchHelpRoutingNumber: {
    id: 'app.payment.label.ach.help.routingNumber',
    defaultMessage: '9 Digit Routing Number',
  },
  paymentLabelAchHelpAccountNumber: {
    id: 'app.payment.label.ach.help.accountNumber',
    defaultMessage: 'Account Number',
  },

  // ePayPolicy
  paymentLabelEPayPayment: {
    id: 'app.payment.label.ePayPayment',
    defaultMessage: 'Payment',
  },
  paymentLabelEPaySummary: {
    id: 'app.payment.label.ePaySummary',
    defaultMessage: 'Summary',
  },

  // Payment form
  paymentLabelSelectPolicy: {
    id: 'app.payment.label.selectPolicy',
    defaultMessage: 'Select a Policy',
  },
  paymentLabelRecipientName: {
    id: 'app.payment.label.recipientName',
    defaultMessage: 'Name',
  },
  paymentLabelPaymentAmountCad: {
    id: 'app.payment.label.paymentAmountCad',
    defaultMessage: 'Payment Amount (CAD)',
  },
  paymentLabelCardName: {
    id: 'app.payment.label.cardName',
    defaultMessage: 'Name on Card',
  },

  paymentValidationPolicyNumber: {
    id: 'app.payment.validation.policyNumber',
    defaultMessage: 'Policy number is required!',
  },
  paymentValidationRecipientName: {
    id: 'app.payment.validation.recipientName',
    defaultMessage: 'Name is required!',
  },
  paymentValidationAmount: {
    id: 'app.payment.validation.amount',
    defaultMessage: 'Payment amount is required!',
  },
  paymentValidationCardName: {
    id: 'app.payment.validation.cardName',
    defaultMessage: 'Card name is required!',
  },
  paymentPaymentSuccessfullMessage: {
    id: 'app.payment.success.message',
    defaultMessage: 'Payment successful',
  },
  paymentPaymentSuccessfullDescription: {
    id: 'app.payment.success.description',
    defaultMessage: 'Your payment has been processed',
  },
  paymentPaymentErrorMessage: {
    id: 'app.payment.error.message',
    defaultMessage: 'Payment failed!',
  },
  paymentPaymentErrorDescription: {
    id: 'app.payment.error.description',
    defaultMessage: 'Something went wrong',
  },
  paymentPaymentStripeErrorDescription: {
    id: 'app.payment.error.stripe.description',
    defaultMessage: 'Unable to process your card!',
  },
  paymentErrorPaymentType: {
    id: 'app.payment.error.paymentType',
    defaultMessage: 'Please select a payment type',
  },
  paymentPlaceholderNameOnTheCard: {
    id: 'app.payment.label.nameOnTheCard',
    defaultMessage: 'Name on the card',
  },
})
